var map = {
	"./add-section.svg": "91ef",
	"./flag.svg": "cf21",
	"./location.svg": "ce1d",
	"./progress-shield.svg": "fd2c",
	"./status.svg": "4845",
	"./timer.svg": "8142"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9c8c";